// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3D6s5","inputWrap":"styles_inputWrap__3UdzW","input":"styles_input__4sZU4"};